export default "__VITE_ASSET__Bvxz7n1D__"